import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initial-state";

const { actions, reducer } = createSlice({
  name: "contactUs",
  initialState,
  reducers: {
    setCounterIncrement(state) {
      state.counter += 1;
    },
    setCounterDecrement(state) {
      state.counter -= 1;
    },
    setContactUsFormData(state, actions) {
      const { emailAddress, message, name } = actions.payload;

      state.name = name;
      state.emailAddress = emailAddress;
      state.message = message;
    },
  },
});

export { actions };
export default reducer;
